// extracted by mini-css-extract-plugin
export default {"SecondHeader":"SecondHeader_SecondHeader__s08Ou","increaseOpacity":"SecondHeader_increaseOpacity__hnB8x"};